export const SET_COOKIEMSG = "SET_COOKIEMSG"

export interface SetCookieMsg {
  type: typeof SET_COOKIEMSG
  alreadyShow: boolean
}

export type CookieMsgActionTypes = SetCookieMsg
